import { ProductType, ProductTypeDiscount } from '@mfe/shared/schema-types';

/**
 * Adds a discount to a product type.
 * @param {ProductType} productType - The product type to which the discount will be added.
 * @param {ProductTypeDiscount} discount - The discount to be added.
 * @returns {ProductType} - A new product type with the added discount.
 */

export function addDiscountToProductType(
  productType: ProductType,
  discount: ProductTypeDiscount
): ProductType {
  return {
    ...productType,
    discounts: {
      itemized_discounts: [discount],
      total_discounts: { ...discount },
    },
  };
}
